// extracted by mini-css-extract-plugin
module.exports = {"gwTileHeaderText":"tile-header-text-hashed__gwTileHeaderText__16XsM"};